import { css } from '@emotion/core';
var _ref = {
  name: "g95qiv",
  styles: "width:0;height:0;border-style:solid;"
};
export default function simpleArrow(height, width, direction, color) {
  var shared = _ref;
  if (direction === 'left') {
    return /*#__PURE__*/css(shared, " border-width:", height, " ", width, " ", height, " 0;border-color:transparent ", color, " transparent transparent;");
  }
  if (direction === 'right') {
    return /*#__PURE__*/css(shared, " border-width:", height, " 0 ", height, " ", width, ";border-color:transparent transparent transparent ", color, ";");
  }
  if (direction === 'up') {
    return /*#__PURE__*/css(shared, " border-width:0 ", width, " ", height, ";border-color:transparent transparent ", color, ";");
  }

  // Defaults to down if direction is not a valid string
  return /*#__PURE__*/css(shared, " border-width:", height, " ", width, " 0;border-color:", color, " transparent transparent;");
}